import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  isLoading: false,
  userList: [],
  pagination: {},
  userDetail: {},
  loading: false,
  error: null,
  accountStatusData: {},
  coreValueData: {},
  postListData: [],
  commentListData: [],
  userListData: {
    userList: [],
    pagination: {}
  },
  userDetailData: {},
  freezeProfileFirstModalState: false,
  freezeProfileSecondModalState: false,
  removeProfileModalState: false,
  removeProfileSuccess: false,
  emailList: [],
  addUserSuccess: false,
  userDeleteSuccess : null,
  userListSuccess : null
};



const userManagementSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    userListManageMentLoad: (state) => {
      state.isLoading = true;
      state.userListSuccess =  false;
    },
    userListManageMentSuccess: (state, action) => {
      state.isLoading = false;
      state.userList = action.payload.data;
      state.pagination = action.payload.pagination;
      state.userListSuccess = true;
    },
    userListFailed: (state) => {
      state.isLoading = false;
    },
    userDeleteLoad: (state) => {
      state.isLoading = true;
      state.userDeleteSuccess = false;
    },
    userDeleteSuccess: (state) => {
      state.isLoading = false;
      state.userDeleteSuccess = true;
    },
    userDeleteFailed: (state) => {
      state.isLoading = false;
    },
    addUserLoad: (state) => {
      state.isLoading = true;
      state.addUserSuccess = false
    },
    addUserSuccess: (state) => {
      state.isLoading = false;
      state.addUserSuccess = true

    },
    addUserFail: (state) => {
      state.isLoading = false;
      state.addUserSuccess = false
    },

    // MOHIT CODE

    // Account Status
    accountStatusLoad: (state) => {
      state.loading = true
    },
    accountStatusSuccess: (state, action) => {
      state.loading = false
      state.accountStatusData = action.payload
    },
    accountStatusFail: (state) => {
      state.loading = false
    },

    // Core Value
    coreValueLoad: (state) => {
      state.loading = true
    },
    coreValuesSuccess: (state, action) => {
      state.loading = false
      state.coreValueData = action.payload
    },
    coreValueFail: (state) => {
      state.loading = false
    },

    // User List
    userListLoad: (state) => {
      state.loading = true
    },
    userListSuccess: (state, action) => {
      state.loading = false
      state.userListData = action.payload
    },
    userListFail: (state) => {
      state.loading = false
    },

    // User List
    userDetailLoad: (state) => {
      state.loading = true
    },
    userDetailSuccess: (state, action) => {
      state.loading = false
      state.userDetailData = action.payload
    },
    userDetailFail: (state) => {
      state.loading = false
    },

    freezeModalFirstHandler: (state) => {
      state.freezeProfileFirstModalState = !state.freezeProfileFirstModalState
    },
    freezeModalSecondHandler: (state) => {
      state.freezeProfileSecondModalState = !state.freezeProfileSecondModalState
    },

    freezeProfileLoad: (state) => {
      state.loading = true
    },
    freezeProfileSuccess: (state) => {
      state.loading = true
      state.freezeProfileFirstModalState = false
      state.freezeProfileSecondModalState = false
    },
    freezeProfileFail: (state) => {
      state.loading = true
      state.freezeProfileFirstModalState = false
      state.freezeProfileSecondModalState = false

    },
    removeProfileModal: (state) => {
      state.removeProfileModalState = !state.removeProfileModalState
      state.removeProfileSuccess = false
    },
    removeProfileLoad: (state) => {
      state.loading = true
      state.removeProfileSuccess = false
    },
    removeProfileSuccess: (state) => {
      state.loading = true
      state.removeProfileSuccess = true
      state.removeProfileModalState = false
    },
    removeProfileFail: (state) => {
      state.loading = true
      state.removeProfileSuccess = false
      state.removeProfileModalState = false

    },

    emailSearchLoad: (state) => {
      state.loading = true
    },
    emailSearchSuccess: (state, action) => {
      state.loading = true
      state.emailList = action.payload
    },
    emailSearchFail: (state) => {
      state.loading = true
    },

    ///// Post list Saga ////////

    getPostListLoad: (state) => {
      state.loading = true;
      state.error = null;
    },
    getPostListSuccess: (state, action) => {
      state.loading = false;
      state.error = false
      state.postListData = action.payload;
    },
    getPostFail: (state) => {
      state.loading = false;
      state.error = true;
    },

    userCommentListLoad(state) {
      state.loading = false;
      state.error = false
    },
    userCommentListSuccess(state, action) {
      state.loading = false;
      state.error = false
      state.commentListData = action.payload;
    },
    userCommentListFail(state) {
      state.loading = false;
      state.error = false
    },


    // Make Super User
    makeSuperUserLoad(state) {
      state.loading = false;
      state.error = false
    },
    makeSuperUserSuccess(state) {
      state.loading = false;
      state.error = false
    },
    makeSuperUserFail(state) {
      state.loading = false;
      state.error = false
    },
  }
});

export const {
  userListManageMentLoad,
  userListManageMentSuccess,
  userListFailed,
  userDeleteLoad,
  userDeleteSuccess,
  userDeleteFailed,
  addUserLoad,
  addUserSuccess,
  addUserFail,
  // MOHIT CODE
  accountStatusLoad,
  accountStatusSuccess,
  accountStatusFail,
  coreValueLoad,
  coreValuesSuccess,
  coreValueFail,
  userListLoad,
  userListSuccess,
  userListFail,
  userDetailLoad,
  removeProfileModal,
  userDetailSuccess,
  userDetailFail,
  freezeModalFirstHandler,
  freezeModalSecondHandler,
  freezeProfileLoad,
  freezeProfileSuccess,
  freezeProfileFail,
  removeProfileLoad,
  removeProfileSuccess,
  removeProfileFail,
  emailSearchLoad,
  emailSearchSuccess,
  emailSearchFail,
  //////// Dheeraj code //////////
  getPostListLoad,
  getPostListSuccess,
  getPostFail,
  userCommentListLoad,
  userCommentListSuccess,
  userCommentListFail,
  makeSuperUserLoad,
  makeSuperUserSuccess,
  makeSuperUserFail

} = userManagementSlice.actions;

export default userManagementSlice.reducer;
